// src/components/ui/TabPanel.jsx
import React from 'react';
import { Box, styled, alpha } from '@mui/material';

/**
 * Styled panel container for better visibility and spacing
 */
const PanelContainer = styled(Box)(({ theme }) => ({
  padding: 0,
  backgroundColor: 'transparent',
  position: 'relative',
  color: theme.palette.mode === 'dark'
    ? alpha(theme.palette.common.white, 0.95)
    : alpha(theme.palette.common.black, 0.95),
  transition: theme.aghrba.tokens.transitions.standard,
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: theme.palette.mode === 'dark'
      ? alpha(theme.palette.background.paper, 0.05)
      : alpha(theme.palette.background.paper, 0.02),
    borderRadius: theme.aghrba.tokens.borderRadius.medium,
    zIndex: 0,
  }
}));

/**
 * Enhanced Tab Panel component for tabbed interfaces
 * @param {Object} props
 * @param {React.ReactNode} props.children - Tab content
 * @param {number} props.value - Current tab value
 * @param {number} props.index - This tab's index
 */
const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`content-tabpanel-${index}`}
      aria-labelledby={`content-tab-${index}`}
      style={{ marginTop: '24px' }}
      {...other}
    >
      {value === index && (
        <PanelContainer>
          {children}
        </PanelContainer>
      )}
    </div>
  );
};

export default TabPanel;
